RivalIQ.apps.Shell.module('mixins', function (mixins, App, Backbone, Marionette, $, _) {

    'use strict';

    mixins.CompanySetEventsMixin = {
        afterConstruction: function () {
            const me = this;

            Marionette.bindEntityEvents(me, RivalIQ.state.companySets, me.companySetEvents);
        }
    };

    // Reloads the widget/curation if a companySet changed
    mixins.CompanySetChangeReload = _.defaults({

        companySetEvents: {
            'companySetsChanged': 'onCompanySetsChanged',
            'companySetEditingComplete': 'reload'
        },

        onCompanySetsChanged: function (changedCompanySetDescriptor) {
            const me = this;

            if (me.getProp('companySetDescriptor') === changedCompanySetDescriptor) {
                RivalIQ.data.CacheLayer.invalidateAllCaches(false);
            }
        }

    }, RivalIQ.apps.Shell.mixins.CompanySetEventsMixin);

});
